import { STM } from '../context/types';

export const ro_roStatements : STM[]  = [
  {
    "id": 1,
    "valueKey": "samen1",
    "title": "Lucrăm adesea cu alții",
    "title_360_leadership": "stimulează munca în echipă",
    "title_360_workenv": "lucrăm adesea împreună",
    "preferredType": "leadership"
  },
  {
    "id": 2,
    "valueKey": "samen2",
    "title": "Echipa este mai importantă decât persoana", // le groupe est plus important qu'une personne
    "title_360_leadership": "favorizează succesul echipei înaintea propriului său succes",
    "title_360_workenv": "echipa este mai importantă decât persoana",
    "preferredType": "workenv"
  },
  {
    "id": 3,
    "valueKey": "samen3",
    "title": "Lucrăm din greu pentru echipă",
    "title_360_leadership": "se implică pentru echipa sa",
    "title_360_workenv": "facem tot posibilul pentru echipa noastră",
    "preferredType": "leadership"
  },
  {
    "id": 4,
    "valueKey": "conf1",
    "title": "Nu ne exprimăm opinia dacă aceasta duce la un dezacord",
    "title_360_leadership": "nu își exprimă opinia dacă aceasta poate duce la un conflict",
    "title_360_workenv": "nu ne exprimăm opinia dacă aceasta poate duce la un conflict",
    "preferredType": "workenv"
  },
  {
    "id": 5,
    "valueKey": "conf2",
    "title": "Facem tot posibilul pentru a evita certurile",
    "title_360_leadership": "face tot posibilul pentru a evita certurile",
    "title_360_workenv": "facem tot posibilul pentru a evita certurile",
    "preferredType": "leadership"
  },
  {
    "id": 6,
    "valueKey": "conf3",
    "title": "Respectăm regulile și normele",
    "title_360_leadership": "se asigură că respectăm regulile și normele",
    "title_360_workenv": "respectăm regulile și normele",
    "preferredType": "workenv"
  },
  {
    "id": 7,
    "valueKey": "erken1",
    "title": "Suntem respectați de colegi și manager",
    "title_360_leadership": "garantează un mediu în care ne respectăm reciproc",
    "title_360_workenv": "colegii arată respect între ei",
    "preferredType": "workenv"
  },
  {
    "id": 8,
    "valueKey": "erken2",
    "title": "Suntem recunoscuți pentru ceea ce facem",
    "title_360_leadership": "oferă recunoaștere pentru ceea ce facem",
    "title_360_workenv": "primim recunoaștere pentru ceea ce facem",
    "preferredType": "workenv"
  },
  {
    "id": 9,
    "valueKey": "erken3",
    "title": "Contribuția dumneavoastră este apreciată",
    "title_360_leadership": "valorizează efortul depus",
    "title_360_workenv": "efortul este apreciat",
    "preferredType": "leadership"
  },
  {
    "id": 10,
    "valueKey": "zorg1",
    "title": "Suntem binevoitori față de ceilalți",
    "title_360_leadership": "este binevoitor și respectuos",
    "title_360_workenv": "suntem binevoitori și respectuoși",
    "preferredType": "leadership"
  },
  {
    "id": 11,
    "valueKey": "zorg2",
    "title": "Ne asigurăm că fiecare se simte bine", //on s'assure que les autres se sentent bien
    "title_360_leadership": "favorizează o atmosferă în care fiecare se simte bine",
    "title_360_workenv": "ne asigurăm că fiecare se simte bine",
    "preferredType": "workenv"
  },
  {
    "id": 12,
    "valueKey": "zorg3",
    "title": "Ajutăm colegii, clienții sau alți parteneri", //on aide ses collègues, ses clients ou d'autres personnes
    "title_360_leadership": "favorizează un climat de ajutor reciproc",
    "title_360_workenv": "ajutăm colegii, clienții și/sau alți parteneri",
    "preferredType": "leadership"
  },
  {
    "id": 13,
    "valueKey": "gelijk1",
    "title": "Beneficiem de șanse egale",
    "title_360_leadership": "tratează pe toată lumea în mod echitabil",
    "title_360_workenv": "fiecare are șanse egale",
    "preferredType": "workenv"
  },
  {
    "id": 14,
    "valueKey": "gelijk2",
    "title": "Vârsta, originea sau genul dumneavoastră contează puțin",
    "title_360_leadership": "nu face diferențe în funcție de vârstă, origine sau gen",
    "title_360_workenv": "vârsta, originea sau genul dumneavoastră nu contează",
    "preferredType": "workenv"
  },
  {
    "id": 15,
    "valueKey": "gelijk3",
    "title": "Oamenii se uită la ceea ce faci, nu la cine ești",
    "title_360_leadership": "ne evaluează pe baza acțiunilor noastre, nu a personalității noastre",
    "title_360_workenv": "sunt judecați pentru acțiunile lor, nu pentru personalitatea lor",
    "preferredType": "leadership"
  },
  {
    "id": 16,
    "valueKey": "zelfsturing1",
    "title": "Avem libertatea de a decide ce facem",
    "title_360_leadership": "mă lasă să acționez pe cont propriu",
    "title_360_workenv": "avem libertatea de a decide ce facem",
    "preferredType": "workenv"
  },
  {
    "id": 17,
    "valueKey": "zelfsturing2",
    "title": "Ne alegem modul de a lucra",
    "title_360_leadership": "mă lasă să-mi stabilesc propriul mod de lucru",
    "title_360_workenv": "putem determina propria noastră modalitate de lucru",
    "preferredType": "leadership"
  },
  {
    "id": 18,
    "valueKey": "zelfsturing3",
    "title": "Ne planificăm propriile activități",
    "title_360_leadership": "îmi permite să îmi stabilesc propriul program",
    "title_360_workenv": "fiecare poate să își planifice singur activitățile",
    "preferredType": "workenv"
  },
  {
    "id": 19,
    "valueKey": "macht1",
    "title": "Pot influența comportamentul altora",
    "title_360_leadership": "îmi influențează munca",
    "preferredType": "leadership"
  },
  {
    "id": 20,
    "valueKey": "macht2",
    "title": "Spun ce trebuie făcut", // je suis celui/celle qui décide ce qui doit être fait
    "title_360_leadership": "spune ce trebuie făcut",
    "preferredType": "leadership"
  },
  {
    "id": 21,
    "valueKey": "macht3",
    "title": "Decid ce se întâmplă", 
    "title_360_leadership": "decide ce trebuie făcut",
    "preferredType": "disabled"
  },
  {
    "id": 22,
    "valueKey": "voorspelbaar1",
    "title": "Există organizare și regularitate în muncă",
    "title_360_leadership": "încurajează structura și regularitatea",
    "title_360_workenv": "există structură și regularitate",
    "preferredType": "workenv"
  },
  {
    "id": 23,
    "valueKey": "voorspelbaar2",
    "title": "Munca decurge de obicei conform planului",
    "title_360_leadership": "se asigură că programul este respectat",
    "title_360_workenv": "lucrurile decurg de obicei conform planului",
    "preferredType": "leadership"
  },
  {
    "id": 24,
    "valueKey": "voorspelbaar3",
    "title": "Putem păstra valorile tradiționale și modul nostru de gândire",
    "title_360_leadership": "garantează respectul pentru tradiții (valori, gânduri, obiceiuri)",
    "title_360_workenv": "păstrăm tradițiile (valori, gânduri, obiceiuri)",
    "preferredType": "workenv"
  },
  {
    "id": 25,
    "valueKey": "prestatie1",
    "title": "Putem arăta cât de buni suntem",
    "title_360_leadership": "mă încurajează să dau tot ce am mai bun",
    "title_360_workenv": "putem arăta ce este mai bun în noi",
    "preferredType": "leadership"
  },
  {
    "id": 26,
    "valueKey": "prestatie2",
    "title": "Putem arăta ce suntem capabili să facem",
    "title_360_leadership": "ne încurajează să arătăm ce putem face",
    "title_360_workenv": "putem demonstra potențialul nostru",
    "preferredType": "workenv"
  },
  {
    "id": 27,
    "valueKey": "prestatie3",
    "title": "Putem excela în ceea ce facem",
    "title_360_leadership": "mă încurajează să excelez în ceea ce fac",
    "title_360_workenv": "putem excela în ceea ce facem",
    "preferredType": "workenv"
  },
  {
    "id": 28,
    "valueKey": "zelfontplooi1",
    "title": "Putem continua să învățăm",
    "title_360_leadership": "încurajează formarea continuă",
    "title_360_workenv": "putem continua să învățăm",
    "preferredType": "workenv"
  },
  {
    "id": 29,
    "valueKey": "zelfontplooi2",
    "title": "Putem aprofunda cunoștințele noastre",
    "title_360_leadership": "mă încurajează să îmi dezvolt competențele",
    "title_360_workenv": "putem aprofunda cunoștințele noastre",
    "preferredType": "leadership"
  },
  {
    "id": 30,
    "valueKey": "zelfontplooi3",
    "title": "Putem continua să ne dezvoltăm",
    "title_360_leadership": "îi ajută pe ceilalți să se dezvolte",
    "title_360_workenv": "putem continua să ne dezvoltăm",
    "preferredType": "workenv"
  },
  {
    "id": 31,
    "valueKey": "duurzaam1",
    "title": "Oferim un lucru de calitate",
    "title_360_leadership": "se asigură că echipa livrează muncă de calitate",
    "title_360_workenv": "oferim un lucru de calitate",
    "preferredType": "leadership"
  },
  {
    "id": 32,
    "valueKey": "duurzaam2",
    "title": "Respectăm clienții și alte relații", //on respecte les clients et d'autres personnes
    "title_360_leadership": "încurajează echipa să respecte clienții și alte relații",
    "title_360_workenv": "respectăm clienții și celelalte relații",
    "preferredType": "workenv"
  },
  {
    "id": 33,
    "valueKey": "duurzaam3",
    "title": "Ne pasă de oameni, siguranță și mediu",
    "title_360_leadership": "se asigură că persoana, siguranța și mediul sunt luate în considerare",
    "title_360_workenv": "luăm în considerare individul, siguranța și mediul",
    "preferredType": "workenv"
  },
  {
    "id": 34,
    "valueKey": "integriteit1",
    "title": "Ne asumăm responsabilitatea pentru acțiunile noastre",
    "title_360_leadership": "se asigură că ne asumăm responsabilitatea pentru acțiunile noastre",
    "title_360_workenv": "ne asumăm responsabilitatea pentru acțiunile noastre",
    "preferredType": "workenv"
  },
  {
    "id": 35,
    "valueKey": "integriteit2",
    "title": "Oamenii sunt cinstiți",
    "title_360_leadership": "este cinstit",
    "title_360_workenv": "suntem cinstiți",
    "preferredType": "workenv"
  },
  {
    "id": 36,
    "valueKey": "integriteit3",
    "title": "Sunt discreți cu informațiile confidențiale",
    "title_360_leadership": "tratează cu grijă informațiile personale și confidențiale",
    "title_360_workenv": "tratăm informațiile personale și confidențiale cu grijă",
    "preferredType": "leadership"
  },
  {
    "id": 37,
    "valueKey": "innovatie1",
    "title": "Putem încerca noi modalități de a lucra",
    "title_360_leadership": "ne încurajează să încercăm noi metode de lucru",
    "title_360_workenv": "putem încerca noi modalități de a lucra",
    "preferredType": "leadership"
  },
  {
    "id": 38,
    "valueKey": "innovatie2",
    "title": "Facem multe experiențe noi", //on peut découvrir beaucoup de nouvelles choses
    "title_360_leadership": "mă încurajează să dobândesc noi experiențe",
    "title_360_workenv": "facem multe experiențe noi",
    "preferredType": "workenv"
  },
  {
    "id": 39,
    "valueKey": "innovatie3",
    "title": "Putem găsi noi provocări", 
    "title_360_leadership": "ne stimulează să găsim noi provocări",
    "title_360_workenv": "putem găsi noi provocări",
    "preferredType": "leadership"
  },
  {
    "id": 40,
    "valueKey": "daadkracht1",
    "title": "Lucrăm din proprie inițiativă",
    "title_360_leadership": "mă încurajează să inițiez singur sarcini",
    "title_360_workenv": "ne punem la treabă din proprie inițiativă",
    "preferredType": "workenv"
  },
  {
    "id": 41,
    "valueKey": "daadkracht2",
    "title": "Ne asigurăm că obținem rezultate", // on s'assure que les résultats sont atteints
    "title_360_leadership": "se asigură că rezultatele sunt atinse",
    "title_360_workenv": "ne asigurăm că obținem rezultate",
    "preferredType": "leadership"
  },
  {
    "id": 42,
    "valueKey": "daadkracht3",
    "title": "Facem tot posibilul pentru a atinge obiectivele",
    "title_360_leadership": "face tot posibilul pentru a atinge obiectivele stabilite",
    "title_360_workenv": "facem tot posibilul pentru a atinge obiectivele propuse",
    "preferredType": "leadership"
  }
]

export const extra360Ro_RoStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'ia decizii',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          "respectă și apreciază diferențele dintre membrii echipei",
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'oferă feedback constructiv',
      preferredType: 'leadership',
    },
]

